import type { MutableRefObject } from 'react'
import { useCallback } from 'react'

type SyncableRefs<Type> =
  | MutableRefObject<Type>
  | ((instance: Type) => void)
  | null
  | undefined

export function useSyncRefs<Type>(
  ...refs: SyncableRefs<Type>[]
): (value: Type) => void {
  return useCallback(
    (value: Type): void => {
      refs.forEach((ref) => {
        if (ref === null || ref === undefined) {
          return
        }

        if (typeof ref === 'function') {
          return ref(value)
        }

        ref.current = value
      })
    },
    [refs],
  )
}
